import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Bell, Menu, X } from "lucide-react";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
            <div className="w-8 h-8 bg-gradient-to-r from-teal-400 to-blue-500 rounded-lg flex items-center justify-center">
              <Bell className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold">Sera</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#benefits" className="text-slate-300 hover:text-white transition-colors">Benefits</Link>
            <Link to="/#features" className="text-slate-300 hover:text-white transition-colors">Features</Link>
            <Link to="/#pricing" className="text-slate-300 hover:text-white transition-colors">Pricing</Link>
            <Link to="/#testimonials" className="text-slate-300 hover:text-white transition-colors">Testimonials</Link>
            <Link to="/#faq" className="text-slate-300 hover:text-white transition-colors">FAQ</Link>
            <Link to="/blog" className="text-slate-300 hover:text-white transition-colors">Blog</Link>
          </div>

              <div className="flex items-center space-x-4">
                <button className="group hover:scale-105 transition-all duration-300 ease-out p-1 rounded-lg bg-gradient-to-r from-teal-400 to-blue-500 hover:from-teal-300 hover:to-blue-400">
                  <img 
                    src="/GetItOnGooglePlay_Badge_Web_color_English.png" 
                    alt="Get it on Google Play" 
                    className="h-8 w-auto rounded-md group-hover:drop-shadow-[0_8px_25px_rgba(20,184,166,0.4)] group-hover:drop-shadow-[0_4px_15px_rgba(59,130,246,0.3)] transition-all duration-300"
                  />
                </button>
            <button 
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden py-4 space-y-2"
          >
            <Link to="/#benefits" className="block py-2 text-slate-300 hover:text-white">Benefits</Link>
            <Link to="/#features" className="block py-2 text-slate-300 hover:text-white">Features</Link>
            <Link to="/#pricing" className="block py-2 text-slate-300 hover:text-white">Pricing</Link>
            <Link to="/#testimonials" className="block py-2 text-slate-300 hover:text-white">Testimonials</Link>
            <Link to="/#faq" className="block py-2 text-slate-300 hover:text-white">FAQ</Link>
            <Link to="/blog" className="block py-2 text-slate-300 hover:text-white">Blog</Link>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;